import { CustomHTMLElement, Utils } from '../../../../common/utils';
import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { Router } from '@angular/router';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { environment } from 'src/environments/environment';
import { StorageManager } from '../../../../common/storage-manager.class';
import { firstValueFrom, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseView } from 'src/app/view/base-view';
import esLocale from '@fullcalendar/core/locales/es';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { TareasApiService } from 'src/app/service/api/tareas-api.service';
import type { OnInit, AfterViewInit, ComponentRef } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { Calendar, CalendarOptions, EventClickArg, EventMountArg } from '@fullcalendar/core';
import { CalendarioTareaModel } from 'src/app/models/tareas/calendario-tarea.model';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { TareaFitoModel } from 'src/app/models/tareas/tarea-fito.model';
import { TareaFertiModel } from 'src/app/models/tareas/tarea-ferti.model';
import { TareasBioModel } from 'src/app/models/tareas/tareas-bio.model';
//import { BaseResponseModel } from 'src/base-response.model';
import { ContextualOptionModel } from 'src/app/models/contextual-menu-item.model';
import { ContextualMenuComponent } from 'src/app/common/components/contextual-menu/contextual-menu.component';
import { BaseResponseModel } from 'src/app/models/base-response.model';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import type { ReactiveFormChangedField, ReactiveFormValue } from 'src/app/common/components/reactive-form-builder/interfaces/reactive-form-change.interface';
import { CalendarioTareasFormDefinition } from './form-control/form-definition';
import { applyResponsiveFullCalendarView, getResponsiveFullCalendarOptions } from '../../../../common/fullcalendar-responsive-options';

@Component({
    selector: 'app-calendario-tareas',
    standalone: false,
    templateUrl: './calendario-tareas.component.html',
    styleUrls: ['./calendario-tareas.component.scss']
})
export class CalendarioTareasComponent extends BaseView<CalendarioTareaModel> implements OnInit, AfterViewInit {

    @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
    
    public eventForm: CalendarioTareasFormDefinition | null = null;
    public eventRequest = this.tareasApi.eventos.POST;
    public eventGetRequest = this.tareasApi.eventos.GET;

    public options2 = {
        height: 400,
        width: 400,
        aspectRatio: 0.4
    };

    public months = [
        {name: 'Enero', value: 1},
        {name: 'Febrero', value: 2},
        {name: 'Marzo', value: 3},
        {name: 'Abril', value: 4},
        {name: 'Mayo', value: 5},
        {name: 'Junio', value: 6},
        {name: 'Julio', value: 7},
        {name: 'Agosto', value: 8},
        {name: 'Septiembre', value: 9},
        {name: 'Octubre', value: 10},
        {name: 'Noviembre', value: 11},
        {name: 'Diciembre', value: 12},
    ];
    public years: {name: string, value: number}[] = [];
    
    public tipos = [
        {name: 'Agro', value: 'Agro'},
        {name: 'Garden', value: 'Garden'},
        {name: 'Todos', value: 'Todos'},
    ];
    public readonly selectedMonthControl = new FormControl<number | null>(null);
    public readonly selectedYearControl = new FormControl<number | null>(null);
    public readonly selectedTipoControl = new FormControl<string | null>('Todos');

    public override model: CalendarioTareaModel = {};

    public calendarApi!: Calendar;

    public hasClients = environment.features.hasClients;
    public hasFincas = environment.features.hasFincas;
    public clienteName = environment.features.clienteName;
    public fincaName = environment.features.fincaName;
    public fincasName = environment.features.fincasName;

    public tareasFitosanitarias = environment.features.showTareasFitosanitarias;
    public tareasFertilizantes = environment.features.showTareasFertilizantes;
    public tareasSiembra = environment.features.showTareasSiembra;
    public tareasBio = environment.features.showTareasBio;
    public tareasGenericas = environment.features.showTareasOtros;
    public tareasEventos = environment.features.showTareasEventos;    

    public readonly env = environment;
    public appName = environment.appName;    
    public isAdmin = (StorageManager.getUser().rol === 'admin');
    public deleteRequestFito: RequestHandler<TareaFitoModel> = this.tareasApi.fitosanitariosDELETE;
    public deleteRequestFerti: RequestHandler<TareaFertiModel> = this.tareasApi.fertilizantes.DELETE;
    public deleteRequestBio: RequestHandler<TareasBioModel> = this.tareasApi.bio.DELETE;
    
    public tareaSeleccionada: CalendarioTareaModel = {};
    public tareasArray: CalendarioTareaModel[] = [];
    public tareasArrayFiltered: CalendarioTareaModel[] = [];
    public tareas: CalendarioTareaModel[] = [];

    public clientChange: Subscription = new Subscription();
    public isMobile = false;

    public date: Date | null = new Date();
    public fechaSel = '';
    public tareaDia = [];
    public showEditTarea = false;
    public showEliminaTarea = false;

    public cambiaEstadoLabel = '';
    public cambiaEstadoColor = '';
    public cambiandoEstado = false;
    
    public selector: Element | undefined;

    public showCreateEventDialog = false;
    public showDeleteButton = false;

    public distributionOrder = [2];
    
    public options: CalendarOptions = {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        locale: esLocale,
        ...getResponsiveFullCalendarOptions(),
        editable: true,
        windowResize: () => {
            applyResponsiveFullCalendarView(this.calendarComponent);
        },
        eventClick: (event: EventClickArg) =>  { 
            this.irAlEvento(event);
        },
        dateClick: (arg: DateClickArg) => {
            this.crearEvento(arg.date);
        },
        dayCellDidMount: (arg) => {
            arg.el.addEventListener('contextmenu', (e: MouseEvent) => {
                e.preventDefault();
                this.onDateRightClick(arg.date, e);
            });
        },
        eventDidMount: function (info: EventMountArg) {
            
            info.el.addEventListener('contextmenu', (ev) => {
                ev.preventDefault();
                //this.$refs.copyMenu.open(ev, info.event)
                return false;
            }, false);
                
            if ((info.el as CustomHTMLElement).fcSeg.eventRange.def.title) {
                const a = info.el.getElementsByClassName('fc-event-title');
    
                if (a[0]) {
                    a[0].innerHTML = (info.el as CustomHTMLElement).fcSeg.eventRange.def.title;
                }
                
                if (info.event._def.extendedProps['filter']) {
                    const filtro = StorageManager.getCalendarFilter();
                    if (filtro && filtro !== 'Todos' && filtro !== info.event._def.extendedProps['filter']) {
                        info.event.setProp('display', 'none');
                    }
                }
            }
        },
        
    };
    private contextMenuRef?: ComponentRef<ContextualMenuComponent>;

    constructor(
        private viewContainerRef: ViewContainerRef,
        private tareasApi: TareasApiService,
        private dashboard: DashboardService,
        private router: Router,
        public http: HttpClient
    ) {
        super(dashboard, tareasApi.eventos.GET);
        for (let i = 2017; i <= 2025; i++) {
            this.years.push( {name: i.toString(), value: i} );
        }
    }
        
    
    ngOnInit() {
        this.isMobile = (
            ((navigator.userAgent.match('iPad') || []).length > 0) ||
            ((navigator.userAgent.match('iPhone') || []).length > 0) ||
            ((navigator.userAgent.match('iPod') || []).length > 0) || 
            ((navigator.userAgent.match('Android') || []).length > 0)
        );

        this.selectedTipoControl.setValue(StorageManager.getCalendarFilter() || 'Todos');
        this.dashboard.setSubmenuItem('tareas', 'calendario-tareas');

        this.dashboard.clientChanges$.subscribe(() => {
            this.filtrarPorTipoCliente();
        });

        this.dashboard.changeClientActive = true;

        if (localStorage.getItem('tarea_temp')) {
            this.tareaSeleccionada = JSON.parse(localStorage.getItem('tarea_temp') ?? '')[0];
            localStorage.removeItem('tarea_temp');
        }

        this.getTareas();
    }

    ngAfterViewInit() {
        this.calendarApi = this.calendarComponent.getApi();
        applyResponsiveFullCalendarView(this.calendarComponent);

        const elements: HTMLCollectionOf<Element> = document.getElementsByClassName('fc-view');

        const elementsArray = Array.from(elements);
  
        for (const element of elementsArray) {
            element.classList.add('no-zindex');
        }
    }

    getTareas() {
        this.tareasArray = [];
        this.tareasArrayFiltered = [];
        if (this.appName === 'detorres') {
            this.tareasApi.eventos.GET.safePerform();
            this.tareasApi.eventos.GET.response(data => {
                this.tareasArray = data;
                this.tareasArrayFiltered = this.tareasArray
                    .map((it: CalendarioTareaModel) => {
                        let color = '#1a9c86';
                        if (this.appName === 'detorres'){
                            switch (it.tipo_evento) {
                            case 'boda':
                                color = '#08ce23';
                                break;
                            case 'empresa':
                                color = '#f1a11c';
                                break;
                            case 'degustacion':
                                color = '#15efe5';
                                break;
                            default:
                                color = '#1a9c86';
                                break;
                            }
                        }
                        let start = '';
                        if(it.start){
                            start = this.convertDateToISO(it.start) ?? '';
                        }

                        let end = '';
                        if(start){
                            end = start ?? '';
                        }
                        if (this.appName === 'agrosalvi') { 
                            end = moment(
                                Utils.toDate(it.start ?? '')
                            ).format('YYYY-MM-DD');
                        }

                        return {
                            id: it.id?.toString() ?? '',
                            title: it.title ?? '',
                            hora_inicio: it.hora_inicio,
                            hora_fin: it.hora_fin,
                            filter: '',
                            start,
                            end,
                            color,
                        } as CalendarioTareaModel;
                    });
                this.tareasApi.eventos.GET.unsuscribe();
            });
        } else {
            this.tareasApi.calendarioGET.safePerform();
            this.tareasApi.calendarioGET.response(data => {

                const contador = 1;

                this.tareas = data;
                this.tareasArray = data
                    .map((it: CalendarioTareaModel) => {
                        let color = '';

                        const start = moment(
                            Utils.toDate(it.fecha_inicio ?? '')
                        ).format('YYYY-MM-DD');

                        let end = '';
                        if (this.appName === 'agrosalvi') { 
                            end = moment(
                                Utils.toDate(it.fecha_fin ?? '')
                            ).format('YYYY-MM-DD');
                        }



                        switch (it.tipo_tarea) {
                        case 'fito':
                            if (it.estado === 'orden') {
                                color = '#ed7979';
                            } else {
                                color = '#f44242';
                            }
                            break;
                        case 'ferti':
                            if (it.estado === 'orden') {
                                color = '#f7b95c';
                            } else {
                                color = '#ff9a02';
                            }
                            break;
                        case 'bio':
                            if (it.estado === 'orden') {
                                color = '#83e689';
                            } else {
                                color = '#3be246';
                            }
                            break;
                        case 'siembra':
                            if (it.estado === 'orden') {
                                color = '#5fa8f5';
                            } else {
                                color = '#4198f4';
                            }
                            break;
                        case 'genérica':
                            if (it.estado === 'orden') {
                                color = '#e96bff';
                            } else {
                                color = '#d900ff';
                            }
                            break;
                        }


                        if (!this.hasClients) {
                            let descriptorEvento = 'Tarea: ' + it.nombre_tarea + '</br>' + 
                                'Trabajadores: ' + it.trabajadores + '</br>';
                            if (it.maquinarias) {
                                descriptorEvento += 'Maquinaria: ' + it.maquinarias  + '</br>';
                            }
                            descriptorEvento += 'Parcelas: ' + it.parcelas;
                            return {
                                id: contador.toString(),
                                title: descriptorEvento,
                                filter: '',
                                id_tarea: it.id_tarea ?? '',
                                tipo_tarea: it.tipo_tarea ?? '',
                                start,
                                end,
                                color
                            };
                        } else {
                            return {
                                id: contador.toString(),
                                title: 'Tarea: ' + it.tipo_tarea + '</br>' + 
                                'Estado: ' + it.estado + '</br>' +
                                'Cliente: ' + it.nombre_cliente + '</br>' + 
                                'Finca: ' + it.nombre_finca,
                                filter: it.tipo_cliente,
                                id_tarea: it.id_tarea ?? '',
                                tipo_tarea: it.tipo_tarea ?? '',
                                tipo_cliente: it.tipo_cliente ?? '',
                                start,
                                end,
                                color
                            };
                        }

                    });
                this.filterArray();
                this.tareasApi.calendarioGET.unsuscribe();
            });
        }

    }

    filterArray() {
        const clienteActual = StorageManager.getClient();
        
        this.tareasArrayFiltered = this.tareasArray.filter(it => {
            if (this.hasClients) {
                if (clienteActual && clienteActual.nombre && it.title) {
                    return it.title.includes(clienteActual.nombre);
                } else {
                    return it;
                }
            }
            return it;
        });
    }

    convertDateToISO(dateString: string): string {
        const [day, month, year] = dateString.split('-');
        return `${year}-${month}-${day}`;
    }
    
    showSelectedDate(calendar: FullCalendarComponent) {
        const day = new Date().getDate();
        const month = this.selectedMonthControl.value ?? new Date().getMonth() + 1;
        const year = this.selectedYearControl.value ?? new Date().getFullYear();
        const date = new Date(`${year}-${month}-${day}`);
        const monthValue = month.toString().padStart(2, '0');

        this.tareasApi.eventos.GET.safePerform({ mes: monthValue + '/' + year } as never);

        calendar.getApi().gotoDate(date.getTime());
    }


    filtrarPorTipoCliente () {
        StorageManager.saveCalendarFilter(this.selectedTipoControl.value || 'Todos');
        window.location.reload();
    }

    crearEvento(arg: Date) {
        const dateStr = moment(arg).format('DD-MM-YYYY');

        this.model = { start: dateStr };
        this.eventRequest = this.tareasApi.eventos.POST;
        this.eventForm = new CalendarioTareasFormDefinition(FormType.CREATION, this.model);
        this.showCreateEventDialog = true;
        this.showDeleteButton = false;
    }

    redireccion(arg: Date, type: string) {
        const dateStr = moment(arg).format('DD/MM/YYYY');
        let newDirection = '';
        
        switch (type) {
        case 'Fitosanitaria':
            newDirection = 'crear-fitosanitario';
            break;
        case 'Fertilizante':
            newDirection = 'crear-fertilizante-tarea';
            break;
        case 'Otra':
            newDirection = 'tareas-crear-otra';
            break;
        
        default:
            break;
        }
        this.router.navigate(['dashboard', newDirection], {
            queryParams: { date: dateStr }
        });
    }

    onDateRightClick(date: Date, event: MouseEvent) {
        event.preventDefault();
    
        // Remove existing context menu if any
        if (this.contextMenuRef) {
            this.contextMenuRef.destroy();
        }

        const optionsMenu : ContextualOptionModel[] = [
            {label: 'Fitosanitaria', icon: 'pi pi-plus', action: () => this.redireccion(date, 'Fitosanitaria')},
            {label: 'Fertilizante', icon: 'pi pi-plus', action: () => this.redireccion(date, 'Fertilizante')},
            {label: 'Otra', icon: 'pi pi-plus', action: () => this.redireccion(date, 'Otra')}
        ];
    
        // Create context menu component
        this.contextMenuRef = this.viewContainerRef.createComponent(ContextualMenuComponent);
        this.contextMenuRef.instance.x = event.clientX;
        this.contextMenuRef.instance.y = event.clientY;
        this.contextMenuRef.instance.date = date;
        this.contextMenuRef.instance.options = optionsMenu;
    
        // Close on any other click
        const removeOnClick = () => {
            this.contextMenuRef?.destroy();
            document.removeEventListener('click', removeOnClick);
        };
        setTimeout(() => document.addEventListener('click', removeOnClick));
    }

    horaStringToDate(hora: string): Date | null {
        if (!hora || typeof hora !== 'string') {return null;}

        const [h, m] = hora.split(':');
        const hour = Number(h);
        const minute = Number(m);

        if (isNaN(hour) || isNaN(minute)) {return null;}

        const date = new Date();
        date.setHours(hour, minute, 0, 0);
        return date;
    }


    irAlEvento(e: EventClickArg) {
        if (this.appName === 'detorres') {
            const selectedEvent = this.tareasArrayFiltered.find((it: CalendarioTareaModel) =>
                it.title === e.event.title &&
                moment(it.start).format('YYYY-MM-DD') === moment(e.event.start).format('YYYY-MM-DD')
            );

            if (!selectedEvent) {
                console.warn('Evento no encontrado en tareasArrayFiltered');
                return;
            }

            this.model = {
                id: selectedEvent.id ?? '',
                title: selectedEvent.title ?? '',
                start: moment(selectedEvent.start, 'YYYY-MM-DD').format('DD-MM-YYYY'),
                hora_inicio: selectedEvent.hora_inicio ?? '',
                hora_fin: selectedEvent.hora_fin ?? '',
                tipo_evento: selectedEvent.tipo_evento ?? '',
            };
            this.eventRequest = this.tareasApi.eventos.PUT;
            this.eventForm = new CalendarioTareasFormDefinition(FormType.EDITION, this.model);
            this.showCreateEventDialog = true;
            this.showDeleteButton = true;

        } else {
            const idTarea = e.event._def.extendedProps['id_tarea'];

            if (idTarea) {
                switch (e.event._def.extendedProps['tipo_tarea']) {
                case 'bio':
                    this.router.navigate(['dashboard', 'editar-bio', idTarea, true ]);
                    break;
                case 'fito':
                    try {
                        (firstValueFrom(this.http.get<BaseResponseModel<TareaFitoModel>>( 
                            environment.serverUrl + 'ws/index.php?p1=tareas&p2=fitosanitarios_get&id=' + idTarea 
                        )))
                            .then( (tarea: BaseResponseModel<TareaFitoModel> ) => {
                                this.router.navigate(['dashboard', 'editar-fitosanitario', idTarea, (tarea.data as TareaFitoModel[])[0]]);
                                return;
                            }).catch ((error: string) => {
                                console.log('catch en getPosition: ' + error);
                            }
                            );
                    } catch (error) {
                        console.log(error);
                    }
                    break;
                case 'ferti':
                    this.router.navigate(['dashboard', 'editar-fertilizante-tarea', idTarea, true ]);
                    break;
                case 'siembra':
                    this.router.navigate(['dashboard', 'tareas-editar-siembra', idTarea, true ]);
                    break;
                case 'genérica':
                    this.router.navigate(['dashboard', 'tareas-editar-otra', idTarea, true ]);
                    break;
                }
            }
            
            for (const tarea of  this.tareas) {
                if (tarea === idTarea) {
                    this.tareaSeleccionada = tarea;
                    break;
                }
            }
        }

    }

   

    reloadCalendario(){
        location.reload();
    } 

    public formChanges(
        formModel: ReactiveFormValue<CalendarioTareaModel>,
        lastChangedFieldName: ReactiveFormChangedField<CalendarioTareaModel>,
    ): void {
        void lastChangedFieldName;

        this.model = {
            ...this.model,
            ...formModel,
        };
    }

    public afterEventSaved(): void {
        this.tareasApi.eventos.GET.reset();
        this.getTareas();
        this.resetDialog();
    }


    override deleteRegister() {
        if (this.model.id) {
            const actualIndex = this.model.id;
            this.tareasApi.eventos.DELETE.safePerform(this.model);
            this.tareasApi.eventos.DELETE.response(() => {
                if (!this.tareasApi.eventos.DELETE.hasError) {
                    this.showCreateEventDialog = false;
                    this.showDeleteButton = false;
                
                    const index = this.tareasArrayFiltered.findIndex(tarea => tarea.id === actualIndex);
                    if (index !== -1) {
                        this.tareasArrayFiltered.splice(index, 1);
                        this.calendarApi.removeAllEvents();
                    }
                }
            });
        } else {
            this.tareasApi.eventos.DELETE.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
      
        this.resetDialog();
    }
    
    resetDialog(){
        this.showCreateEventDialog = false;
        this.showDeleteButton = false;
        this.eventForm = null;
        this.eventRequest = this.tareasApi.eventos.POST;
        this.model = {};
    }
    
}
